<template>
  <section class="max-w-[1200px] w-full px-6 py-16 md:py-24">
    <div class="flex flex-col gap-12 lg:flex-row items-center">
      <div
        v-motion
        class="flex flex-col gap-8 lg:w-1/2"
        :initial="heroMotion.initial"
        :enter="heroMotion.enter"
      >
        <div class="flex flex-col gap-4 text-left">
          <img
            src="/logos/QRestoo-app-logo--rounded.png"
            alt="QRestoo"
            width="64"
            height="64"
            fetchpriority="high"
            class="h-12 w-12 sm:h-16 sm:w-16 object-contain rounded-2xl object-left"
            data-testid="landing-hero-logo"
          />
          <span class="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary w-fit uppercase tracking-widest">
            {{ $t('landing.hero.badge') }}
          </span>
          <h1 class="text-slate-900 dark:text-slate-100 text-4xl font-black leading-tight tracking-[-0.033em] sm:text-6xl">
              {{ $t('landing.hero.titleBefore') }}
              <span class="text-primary">{{ $t('landing.hero.titleHighlight') }}</span>
            </h1>
            <p class="text-slate-600 dark:text-slate-400 text-lg font-normal leading-relaxed">
              {{ $t('landing.hero.subtitle') }}
            </p>
          </div>
          <div class="flex flex-wrap gap-4">
            <router-link
              :to="{ name: 'Register' }"
              class="flex min-w-[160px] cursor-pointer items-center justify-center rounded-xl h-14 px-6 bg-primary text-white text-base font-bold transition-all hover:scale-[1.02] motion-reduce:transform-none shadow-xl shadow-primary/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              {{ $t('landing.nav.getStarted') }}
            </router-link>
            <router-link
              :to="{ name: 'Login' }"
              class="flex min-w-[160px] cursor-pointer items-center justify-center rounded-xl h-14 px-6 border-2 border-primary/20 text-slate-900 dark:text-slate-100 text-base font-bold hover:bg-primary/5 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              {{ $t('landing.nav.goToApp') }}
            </router-link>
          </div>
          <div class="flex items-center gap-4 text-slate-500 text-sm">
            <div class="flex -space-x-2">
              <div class="w-8 h-8 rounded-full border-2 border-background-light bg-slate-200 dark:border-background-dark" aria-hidden="true" />
              <div class="w-8 h-8 rounded-full border-2 border-background-light bg-slate-300 dark:border-background-dark" aria-hidden="true" />
              <div class="w-8 h-8 rounded-full border-2 border-background-light bg-slate-400 dark:border-background-dark" aria-hidden="true" />
            </div>
            <span>{{ $t('landing.hero.trustedBy') }}</span>
          </div>
        </div>
        <div
          v-motion
          class="w-full lg:w-1/2 shrink-0 aspect-video md:aspect-[4/3] bg-primary/5 rounded-3xl overflow-hidden relative border border-primary/10 shadow-2xl"
          :initial="imageMotion.initial"
          :enter="imageMotion.enter"
        >
          <div
            class="absolute inset-0 bg-cover bg-center opacity-90"
            aria-hidden="true"
            alt=""
            style="background-image: url('/landing/decorative.png');"
          />
          <div class="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent" aria-hidden="true" />
        </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useReducedMotion } from '@/composables/useReducedMotion'
const reducedMotion = useReducedMotion()

const heroMotion = computed(() => {
  if (reducedMotion.value) {
    return { initial: { opacity: 1, y: 0 }, enter: { opacity: 1, y: 0, transition: { duration: 0 } } }
  }
  return {
    initial: { opacity: 0, y: 24 },
    enter: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: 80 } },
  }
})

const imageMotion = computed(() => {
  if (reducedMotion.value) {
    return { initial: { opacity: 1, y: 0 }, enter: { opacity: 1, y: 0, transition: { duration: 0 } } }
  }
  return {
    initial: { opacity: 0, y: 24 },
    enter: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: 200 } },
  }
})
</script>
